export default "/corgi/pageapps/purchase/_next/static/media/logo.e4cd74d7.svg";